import React from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import Button from 'components/Button';
import InputDate from 'components/InputDate';

import './DashboardFilter.scss';

const b = block('dashboard-filter-mobile');

const DashboardFilter = ({ filterState }) => {
  const locale = useSelector(state => state.locale.locale.dashboardLocale);

  const { inputState, outputState } = filterState;

  const daysFilterItems = outputState.daysFilterData.map(({ name, value }) => {
    const isActive = value.id === outputState.activeDay;

    return (
      <div className={b('button')} key={value.id}>
        <Button onClick={() => inputState.onChangeDay(value)} color={isActive ? 'pale' : 'transparent'} padding={15}>
          <span className={b('button-text')}>{name}</span>
        </Button>
      </div>
    );
  });

  return (
    <div className={b()}>
      <div className={b('title')}>{locale.showInfo}</div>
      <div className={b('content')}>
        <div className={b('days-filter')}>{daysFilterItems}</div>
        <div className={b('or')}>{locale.or}</div>
        <form className={b('dates')} onSubmit={inputState.onSubmit}>
          <span className={b('label')}>{locale.from}</span>
          <div className={b('input')}>
            <InputDate dateFormat='DD.MM.YYYY HH:mm' value={inputState.values.from} onChange={inputState.onChangeFrom} withTime />
          </div>
          <span className={b('label')}>{locale.to}</span>
          <div className={b('input')}>
            <InputDate dateFormat='DD.MM.YYYY HH:mm' value={inputState.values.to} onChange={inputState.onChangeTo} withTime />
          </div>

          <div className={b('button')}>
            <Button type="submit">
              <div className={b('button-text2')}>{locale.show}</div>
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DashboardFilter;
